<template>
   <div class="hotelCheckout-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="container is-widescreen">
            <div class="hotelCheckout-page-inner row">
               <div class="col-12 col-lg-10 hotel-checkout-inner-wrapper">
                  <!-- ROOM INFO  -->
                  <RoomInfo
                     :countryCode="checkoutResponse.countryCode"
                     :customerNationality="checkoutResponse.customerNationality"
                     :checkinDate="checkoutResponse.checkinDate"
                     :checkoutDate="checkoutResponse.checkoutDate"
                     :roomsList="rooms"
                     :contactModel="checkoutRequestModel.contact"
                     :totalPriceInfo="totalPrice"
                     :insuranceOffers="checkoutResponse.insuranceOffers"
                     @selected-insurance="handleSelectedInsurance"
                     :providerPriceInfo="ProviderPriceDetail"
                     :cancellationPolicies="cancellationPoliciesList"
                     :cancellationPoliciesDate="freeCancellationDate"
                     :isPartialRefund="isPartialRefund"
                     :lastBookingDate="lastBookingDate"
                     @update-to-rooms="setCheckoutRooms"
                     :searchUuidProps="generatedSearchUuid"
                     :totalTax="checkoutResponse.totalTax"
                     :partialPaymentModel="checkoutResponse.installments"
                     :partialPaymentCancellationPolicy="checkoutResponse.installments"
                     :partialPaymentLastBookingDate="checkoutResponse.partialPaymentLastBookingDate"
                     :partialPaymentActive="partialPaymentDateUpdate"
                     @update-selectedAddOns="updateSelectedAddOns" />

                  <!-- CHECKOUT CONTACT -->
                  <!-- <CheckoutContact @update-to-contact="setCheckoutContact" /> -->
                  <CommonCheckoutContact :isShowMail="true" :isBorderavailable="true" @update-to-contact="setCheckoutContact" />

                  <!-- HOTEL INFORMATION -->
                  <HotelDescriptions
                     :providerViewInfo="ProviderPriceDetail"
                     :isExpedia="checkoutResponse.showTermsAndConditions"
                     :providerInstructions="checkoutResponse.providerInstructions"
                     :metaPolicy="checkoutResponse.metaPolicy"
                     @update-to-hotel-description="setCheckoutHotelDescription" />

                  <!-- PAYMENT -->
                  <div class="checkout-payment-container gts-box pt-0">
                     <PaymentPurchaseWidget
                        entityType="hotel"
                        :checkoutRequest="checkoutRequestModel"
                        :paymentChoiceDetail="PaymentChoiceDetail"
                        :funcValidateForm="funcValidateForm"
                        :partialPaymentModel="partialPaymentPaymentModel"
                        :partialPaymentEnabled="checkoutResponse.isPartialPaymentExist"
                        :isChecked="partialPaymentDateUpdate"
                        @toggleChange="sendToggleChange" />
                  </div>
               </div>

               <div class="col-lg-2 col-12">
                  <HotelCheckoutBasket
                     :isPartialWidgetVisible="checkoutResponse.installments?.length == 0 ? false : true"
                     :partialPaymentModel="partialPaymentPaymentModel"
                     v-if="this.$store.state.hotel.basketResponse.isCheckoutBasket"
                     :isPartialPaymentChecked="partialPaymentDateUpdate"
                     @basketPartialPaymentControl="basketPartialPaymentControl" />
               </div>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import Main from "@/components/unitary/Main.vue";

import { hotelService } from "@/service/index.js";

import HotelCheckoutBasket from "@/components/structural/hotel/checkout/CheckoutBasket.vue";
import RoomInfo from "@/components/structural/hotel/checkout/RoomInfo.vue";
// import ExtraServices from '@/components/structural/hotel/checkout/ExtraServices.vue';
// import CheckoutContact from "@/components/structural/hotel/checkout/CheckoutContact.vue";
import HotelDescriptions from "@/components/structural/hotel/checkout/HotelDescriptions.vue";
import PaymentPurchaseWidget from "@/components/structural/payment/PaymentPurchaseWidget.vue";
import CommonCheckoutContact from "@/components/unitary/CommonCheckoutContact.vue";

import Popup from "@/gts-popup.js";
import moment from "moment";

export default {
   name: "HotelCheckoutPage",
   components: {
      Aside,
      Main,
      Navbar,
      HotelCheckoutBasket,
      RoomInfo,
      // ExtraServices,
      // CheckoutContact,
      CommonCheckoutContact,
      HotelDescriptions,
      // PaymentDetail,

      PaymentPurchaseWidget,
   },
   data() {
      return {
         checkoutResponse: {},
         partialPaymentDateUpdate: false,
         rooms: [],
         totalPrice: {},
         cancellationPoliciesList: [],
         freeCancellationDate: "",
         isPartialRefund: null,
         refundable: false,
         lastBookingDate: "",
         checkoutRequestModel: {
            searchUuid: null,
            selectedAddOns: null,
            basketUuid: null,
            selectedInsurance: null,
            refreshCheckout: false,
            trxType: 1,
            payment: {
               paymentType: 1,
            },
            rooms: [],
            contact: {},
            agencyNote: "",
         },
         generatedSearchUuid: "",
         hotelInformation: {
            name: "",
         },
         refreshPayment: 0,
         isPartialPaymentBasketVisible: false,
      };
   },
   computed: {
      partialPaymentPaymentModel() {
         if (!this.checkoutResponse || !this.checkoutResponse.installments) {
            return null;
         }
         const paymentModel = {
            firstPaymentDate: this.checkoutResponse.installments[0]?.dueDate,
            secondPaymentDate: this.checkoutResponse.installments[1]?.dueDate,
            firstPaymentPrice: this.checkoutResponse.installments[0]?.amount,
            secondPaymentPrice: this.checkoutResponse.installments[1]?.amount,
            currency: this.checkoutResponse.installments[0]?.currency,
         };
         return paymentModel;
      },
      PaymentChoiceDetail() {
         return this.checkoutResponse ? this.checkoutResponse.paymentChoiceDetail : null;
      },

      ProviderPriceDetail() {
         return this.checkoutResponse ? this.checkoutResponse.priceDetail : null;
      },
   },
   mounted() {
      var self = this;
      self.checkoutRequestModel.searchUuid = this.$route.params.uuid;
      self.checkoutRequestModel.basketUuid = this.$route.params.basketuuid;
      hotelService
         .hotelCheckout(self.checkoutRequestModel)
         .then((response) => {
            if (!response.result.success) {
               Popup.result(response.result, self.handlerCloseCheckout).then(() => {
                  self.handlerCloseCheckout();
               });
               return;
            } else {
               self.checkoutResponse = response;

               var checkinDate = response.checkinDate;
               var checkoutDate = response.checkoutDate;
               var diffDate = moment(checkoutDate).diff(moment(checkinDate), "days");

               var checkoutBasketModel = {
                  rooms: response.rooms,
                  diffDate: diffDate,
                  totalAmount: response.totalPrice,
                  selectedInsuranceTotal: response.totalPrice.insuranceTotal,
                  isCheckoutBasket: true,
                  hotelInformation: {
                     name: response.hotelName,
                     address: response.hotelAddress,
                     star: response.hotelStar,
                  },
               };
               this.$store.commit("hotel/updateBasketResponse", checkoutBasketModel);

               if (response.insuranceOffers && response.insuranceOffers.some((offer) => offer.selected)) {
                  Popup.info(this.$i18n.t("Insurance_lblPaymentMethodChange"), this.$i18n.t("Insurance_txtCannotReserveWithInsurance"));
               }

               self.rooms = response.rooms;
               self.rooms &&
                  self.rooms.map((roomItem) => {
                     roomItem.checkinDate = response.checkinDate;
                     roomItem.checkoutDate = response.checkoutDate;
                     roomItem.refundable = response.refundable;
                  });
               self.totalPrice = response.totalPrice;
               self.cancellationPoliciesList = response.cancellationPolicies;
               self.freeCancellationDate = response.freeCancellationDate;
               self.isPartialRefund = response.isPartialRefund;
               self.lastBookingDate = response.lastBookingDate;
               self.hotelInformation.name = response.hotelName;
            }
            this.$store.commit("hotel/setHotelCheckoutPageLoadStatus", true);
         })
         .then(() => {
            self.generatedSearchUuid = self.checkoutRequestModel.searchUuid;
         });
   },
   methods: {
      handleSelectedInsurance(selectedInsurance) {
         this.checkoutRequestModel.selectedInsurance = selectedInsurance;
      },
      updateSelectedAddOns(val) {
         this.checkoutRequestModel.selectedAddOns = val;
      },
      basketPartialPaymentControl(isChecked) {
         this.partialPaymentDateUpdate = isChecked;
      },
      sendToggleChange(isChecked) {
         this.partialPaymentDateUpdate = isChecked;
      },
      handlerCloseCheckout() {
         window.close();
      },
      setCheckoutRooms(roomData) {
         var self = this;
         self.checkoutRequestModel.rooms = roomData;
      },
      setCheckoutContact(contactData) {
         var self = this;
         self.checkoutRequestModel.contact = contactData;
      },
      setCheckoutHotelDescription(hotelDescriptionData) {
         var self = this;
         self.checkoutRequestModel.agencyNote = hotelDescriptionData.agencyNote;
      },
      funcValidateForm() {
         var requiredEls = document.querySelectorAll(".v-required");
         var arrayOfNodes = Array.from(requiredEls);
         var first = true;
         var isFormDone = arrayOfNodes.every((el) => {
            let result = el.dataset.isValid === "true";
            el.dataset.allowSubmit = result;
            if (first) {
               el.scrollIntoView();
               first = false;
            }
            return result;
         });
         if (isFormDone) document.body.classList.remove("g-form-invalid");
         else document.body.classList.add("g-form-invalid");
         return isFormDone;
      },
   },
};
</script>

<style lang="scss">
.hotelCheckout-page-wrapper {
   padding-bottom: 10rem;
   @media screen and (min-width: 1408px) {
      .container:not(.is-max-desktop):not(.is-max-widescreen) {
         max-width: 1644px !important;
      }
   }
   .hotelCheckout-page-inner {
      position: relative;
      width: 100%;
      margin: auto;

      .hotel-checkout-inner-wrapper {
         .checkout-section {
            padding: 42px 32px;
            margin-bottom: 24px;
            background-color: var(--surface-level-1);
            background-color: var(--container-bg);
            border: 1px solid var(--gray-300);
            border-radius: 12px;

            &:last-child {
               margin-bottom: 24px;
            }

            .checkout-section-inner {
               .checkout-section-title {
                  margin-bottom: 16px;

                  h4 {
                     font-size: 16px;
                     font-weight: 600;
                     color: var(--gray-700);
                  }
               }
            }
         }
      }
   }
}
</style>
